const enum TopNavMenu {
    Empty = 0,
    Notification = 1,
    User = 2
}

export default TopNavMenu;